export const environment = {
  production: true,
  apiUrl: 'https://ins.gemsbihar.in/api/api/v1',
  apiPayrollUrl: 'https://api.gemsbihar.in/api/v1/payrollApp',
  emailApiUrl: 'https://api.gemsbihar.in/api/v1/mailApp',
  version: 3.3
};